import { type GridColDef } from "@mui/x-data-grid";

import LinkCell from "components/MUI/DataGrid/Cells/Link.cell";
import { dataGridDateGetter } from "components/MUI/DataGrid/DataGrid.utils";

export const labgramColumns: GridColDef[] = [
  {
    headerName: "No.",
    field: "labgram_id",
    flex: 0,
    type: "string",
    valueGetter: (value: number) => value.toString().padStart(3, "0"),
    renderCell: ({ row, value }) => {
      const { labgram_id: id } = row;

      return <LinkCell label={value} to={`${id}`} />;
    },
  },
  {
    headerName: "Subject",
    field: "subject",
    flex: 2,
    renderCell: ({ row }) => {
      const { labgram_id: id, subject } = row;

      return <LinkCell label={subject} to={`${id}`} />;
    },
  },
  {
    headerName: "Date",
    field: "labgram_date",
    type: "date",
    valueGetter: dataGridDateGetter,
    flex: 1,
  },
  {
    headerName: "Author",
    field: "author",
    flex: 1,
  },
];
